import { Component, OnInit, OnDestroy,ViewChild  } from '@angular/core';
import { AlertService } from '../../servicios/alert.service';
import { loading_show, loading_hide } from '../../app.helpers';
import { Result } from '../../servicios/servers.service';
import { TipoServicioService } from '../../servicios/tiposervicio.service';
import { PersonaService } from '../../servicios/persona.service';
import { VehiculoService } from '../../servicios/vehiculo.service';
import swal from 'sweetalert2';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { EmpresaService } from '../../servicios/empresa.service';
import { BsModalComponent,BsModalService  } from 'ng2-bs3-modal';
import { setTimeout } from 'timers';
declare var jQuery: any;

@Component({
    selector: 'servicioReporte',
    templateUrl: 'servicioReporte.template.html'
})

export class ServicioReporte implements OnInit {
    
    constructor(
        private modalservice: BsModalService,
        private personaService: PersonaService,
        private alertService: AlertService,
        private tipoServicioService: TipoServicioService,
        private vehiculoService: VehiculoService,
        private empresaService: EmpresaService,
        private router: Router,
        private route: ActivatedRoute,
    ) {

    }

    @ViewChild('modal')
    public modal: BsModalComponent;
    public empresas = [];
    public recargas = [];
    public sumAceptados = 0;
    public sumFinalizados = 0;
    public sumRechazados = 0;
    public sumCancelados = 0;

    public idEmpresa=0;
    public fecha= {start:"", end:""};
    
    ngOnInit() {
        
        this.getEmpresas();
    }

    getEmpresas() {
        loading_show();
        this.empresaService.getAll((data: any) => {
            loading_hide();
            if (data.isOk) {
                
                this.empresas = data.Content;
                this.idEmpresa  = this.empresas[0].id;
                let fecha = new Date();
                let mes:any = fecha.getMonth() + 1;
                if(mes<10){ mes = '0'+ mes} 
                this.fecha.start =  fecha.getFullYear() + "-" + mes + "-" + fecha.getDate();
                this.fecha.end =  fecha.getFullYear() + "-" + mes + "-" + fecha.getDate();
                this.getReporte();
            }

        });
    }
    
    getReporte() {
        loading_show();
        this.personaService.getServiciosGroupConductoresByEmpresa(this.fecha.start, this.fecha.end,this.idEmpresa,(data: any) => {
            loading_hide();
            if (data.isOk) {
                console.log(data.Content);
                this.recargas = data.Content;
                
                this.getTotal();

            }

        });
    }

    getTotal(){
        this.sumAceptados=0;
        this.sumRechazados=0;
        this.sumFinalizados=0;
        this.sumCancelados=0;
        for(var i =0; i< this.recargas.length;i++){
            
            this.sumAceptados += parseInt(this.recargas[i].aceptado);
            this.sumFinalizados += parseInt(this.recargas[i].finalizado);
            this.sumRechazados += parseInt(this.recargas[i].rechazado);
            this.sumCancelados += parseInt(this.recargas[i].cancelado);
           
        }

        setTimeout(this.animateCounter,500);
        
    }

    animateCounter(){
        jQuery('.counter').each(function () {
            var $this = jQuery(this),
                countTo = $this.attr('id');
            jQuery({ countNum: $this.text() }).animate({
                countNum: countTo
            },

                {

                    duration: 1000,
                    easing: 'linear',
                    step: function () {
                        $this.text(Math.floor(this.countNum));
                    },
                    complete: function () {
                        $this.text(new Intl.NumberFormat("CO").format(this.countNum));
                    }

                });
        });
    }
   
}


// WEBPACK FOOTER //
// ./src/app/views/servicioReporte/servicioReporte.component.ts